import styled from "styled-components";

export const Card = styled.div`
  height: 100%;
  width: 100%;
  /* overflow: hidden; */
  /* position: relative; */
  /* cursor: pointer; */
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover div {
    /* top: 35%; */
  }

  /* @media (min-width: 769px) {
    width: 22rem;
  } */
`;

export const CardDetails = styled.div`
  /* position: absolute; */
  /* bottom: 0; */
  /* top: 100%; */
  /* transition: 0.3s ease top; */
  /* padding: 0 1rem; */

  & a {
    text-decoration: none;
    font-weight: bolder;
    color: f3f3f3;
  }
`;

export const Links = styled.div`
  /* position: absolute; */
  top: 0;
  right: 0;
`;
